'use client'

import React from 'react'
import PrimaryButton from '@/src/components/ui/primary-button'
import SecondaryButton from '@/src/components/ui/secondary-button'
import siteData from '@/public/content/site-data.json'
import TradeVisionProfilesVisual from '@/src/components/visuals/TradeVisionProfilesVisual'

interface TradeVisionProfilesHeroProps {
  title: string
  description: string
  ctaLabel: string
  ctaHref: string
}

export const TradeVisionProfilesHero: React.FC<TradeVisionProfilesHeroProps> = ({
  title,
  description,
  ctaLabel,
  ctaHref
}) => {
  return (
    <section className="px-4">
      <div className="max-w-container mx-auto">
        <div className="grid gap-12 md:grid-cols-2 md:items-start">
          <div className="space-y-6">
            <div className="space-y-4">
              <span className="text-label uppercase tracking-[0.18em] text-link-blue">
                Player intelligence
              </span>
              <h1 className="font-display text-hero tracking-[-0.03em] text-primary">
                {title}
              </h1>
              <p className="text-base leading-8 text-muted md:text-copy-lg">
                {description}
              </p>
            </div>
            <div className="flex gap-3 flex-wrap">
              <PrimaryButton
                href={ctaHref}
                size="lg"
              >
                {ctaLabel}
              </PrimaryButton>
              <SecondaryButton
                href="/pilot"
                size="lg"
              >
                See the pilot
              </SecondaryButton>
            </div>
          </div>
          <div
            className="w-full min-h-[300px] sm:min-h-[350px] md:min-h-[440px] lg:min-h-[500px] rounded-[28px] border border-border-subtle bg-white/[0.03] px-4 sm:px-6 py-6 sm:py-8 text-muted flex items-stretch justify-stretch overflow-hidden"
          >
            <TradeVisionProfilesVisual />
          </div>
        </div>
      </div>
    </section>
  )
}

export default TradeVisionProfilesHero
